module.exports = __webpack_public_path__ + "static/img/article_04.9379132.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/article_04.png
// module id = gF8P
// module chunks = 0